import PropTypes from 'prop-types'
import {
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
  Box,
} from '@chakra-ui/react'
import React from 'react'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

export default function PromotionDetail({ isOpen, onClose, data }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody padding="20px">
          <VStack alignItems="flex-start" spacing={0}>
            <Image
              src={`https://assetsamipass.blob.core.windows.net/commerces/${data?.establishmentId}/${data?.shopId}/logo.png`}
              width="80px"
              height="80px"
              borderRadius={100}
            />
            <Text variant="subtitle1" pt={5} pb={5}>
              {data?.shopName}
            </Text>
            <Text variant="body2">{data?.promotionDescription}</Text>
            <Text variant="body2">Dirección: {data?.shopAddress}</Text>
            {data?.isPresential && data?.endDate && (
              <Text variant="subtitle3" pt={2} pb={2}>
                Vigente hasta:{' '}
                {format(new Date(data.endDate), 'dd-MM-yyyy', { locale: es })}
              </Text>
            )}
            {data?.isOnline && (
              <Box bg="#74BF00" w="100%" p="10px 5px 10px 5px" borderRadius={5}>
                <Text variant="subtitle3" color="#fff">
                  Promoción válida para compras en Tienda Online
                </Text>
              </Box>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

PromotionDetail.propTypes = {
  isOpen: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func,
}
